<template>
  <vs-row>
    <form>
      <vs-tabs alignment="fixed">
        <vs-tab label="Étel adatok">
          <vs-row vs-type="flex">
            <vs-col vs-lg="6" vs-sm="12">
              <vs-input label="Étel név (kötelező)" v-model="item.ItemName"></vs-input>
              <vs-input type="number" label="Étel ár (kötelező)" v-model="item.ItemPrice"></vs-input>
              <vs-input
                label="Ecommerce kódok (Étel név szerinti sorrendben ha az étel többtételes)"
                v-model="ecommerceCodeInput"
                @input="formatEcommerceCode"
              ></vs-input>
              <vs-textarea label="Étlap leírás" v-model="item.ItemDescription"></vs-textarea>
              <vs-checkbox v-model="childItem">Alcikk</vs-checkbox>
              <vs-checkbox v-model="item.Sticky">Rögzített</vs-checkbox>
              <transition name="fade">
                <vs-row v-if="childItem">
                  <vs-select autocomplete placeholder="Válasszon főcikket" label="Főcikk" v-model="item.ParentId">
                    <vs-select-item :value="null" text="Nincs főcikk" />
                    <vs-select-item
                      :key="index"
                      :value="item.ItemId"
                      :text="item.ItemName"
                      v-for="(item, index) in itemList"
                    />
                  </vs-select>
                </vs-row>
              </transition>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12">
              <label for="fileUpload_edit">
                <input
                  id="fileUpload_edit"
                  type="file"
                  style="visibility: hidden"
                  accept=".jpg,.png,.jpeg"
                  @input="setImage()"
                />
                <img alt="Item Image" class="itemImage" :src="imgSrc" />
              </label>
            </vs-col>
          </vs-row>
        </vs-tab>
        <vs-tab label="Címkék">
          <vs-row>
            <transition name="fade" mode="out-in" v-for="(label, index) in item.ItemLabels" :key="index">
              <vs-chip color="primary" transparent closable @click="removeLabel(label)">
                {{ label.LabelName }}
              </vs-chip>
            </transition>
          </vs-row>
          <vs-row>
            <vs-select autocomplete placeholder="Válasszon címkét" label="Címkék" v-model="labelToAdd">
              <vs-select-item :key="index" :value="tr.Id" :text="tr.LabelName" v-for="(tr, index) in labelList" />
            </vs-select>
            <vs-row vs-type="flex" vs-justify="center">
              <vs-button
                @click="addLabel(labelToAdd)"
                color="success"
                type="gradient"
                radius
                icon="add"
                small
              ></vs-button>
            </vs-row>
          </vs-row>
        </vs-tab>
        <vs-tab label="Extrák">
          <vs-row>
            <transition name="fade" mode="out-in" v-for="(addon, index) in item.ItemAddons" :key="index">
              <vs-chip color="primary" transparent closable @click="removeAddon(addon)">
                {{ addon.AddonName }}
              </vs-chip>
            </transition>
          </vs-row>
          <vs-row>
            <vs-select autocomplete placeholder="Válasszon extrákat" label="Extrák" v-model="addonToAdd">
              <vs-select-item :key="index" :value="tr.Id" :text="tr.AddonName" v-for="(tr, index) in addonList" />
            </vs-select>
            <vs-row vs-type="flex" vs-justify="center">
              <vs-button
                @click="addAddon(addonToAdd)"
                color="success"
                type="gradient"
                radius
                icon="add"
                small
              ></vs-button>
            </vs-row>
          </vs-row>
        </vs-tab>
        <vs-tab label="Kategória & Csoport">
          <vs-row>
            <vs-select
              autocomplete
              placeholder="Válasszon kategóriát"
              label="Kategória"
              v-model="menuToAdd"
              @change="updateMenu(menuToAdd)"
            >
              <vs-select-item :value="null" text="Nincs kategória" />
              <vs-select-item :key="index" :value="menu.Id" :text="menu.MenuName" v-for="(menu, index) in menuList" />
            </vs-select>
          </vs-row>

          <vs-row>
            <vs-select
              autocomplete
              placeholder="Válasszon csoportot"
              label="Csoport"
              v-model="categoryToAdd"
              @change="updateCategory(categoryToAdd)"
            >
              <vs-select-item :value="null" text="Nincs csoport" />
              <vs-select-item
                :key="index"
                :value="cat.Id"
                :text="cat.CategoryName"
                v-for="(cat, index) in categoryList"
              />
            </vs-select>
          </vs-row>
        </vs-tab>
      </vs-tabs>

      <vs-row class="justify-content-center" style="margin-top: 15px">
        <vs-button @click="save()" color="success" type="gradient" :disabled="isNotSaveable()">Mentés</vs-button>
      </vs-row>
    </form>
  </vs-row>
</template>

<script>
import { axiosInstance } from "@/main";

export default {
  name: "edit_item",
  props: ["selected", "labelList", "categoryList", "menuList", "addonList", "dailyItem", "itemList"],
  data() {
    return {
      item: "",
      imgSrc: "",
      originalCategory: null,
      originalMenu: null,
      menuToAdd: "",
      categoryToAdd: "",
      addonToAdd: "",
      labelToAdd: "",
      ecommerceCodeInput: "",
      childItem: false,
    };
  },
  watch: {
    selected() {
      this.item = { ...this.selected };
      this.menuToAdd = this.originalMenu = this.item.ItemMenu.MenuId;
      this.categoryToAdd = this.originalCategory = this.item.ItemCategory.CategoryId;
      this.childItem = this.selected.ParentId !== null;
      this.ecommerceCodeInput = this.selected.EcommerceCode || "";
      if (this.selected.ItemFileName !== null && this.selected.ItemFileName !== "")
        this.imgSrc = this.$root.imagePath + this.selected.ItemFileName;
    },
  },
  methods: {
    save() {
      let self = this;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `Megerősítés`,
        text: "Valóban menti a módosításokat?",
        acceptText: "Igen",
        cancelText: "Nem",
        accept: function () {
          let input = document.getElementById("fileUpload_edit");
          let url = self.dailyItem
            ? "admin/dailyMenuItemController.php?action=edit"
            : "admin/itemController.php?action=edit";
          let form = new FormData();

          if (input !== null && input.files !== null && input.files.length !== 0)
            form.append("itemImage", input.files[0]);
          form.append("itemData", JSON.stringify(self.item));

          axiosInstance({
            method: "post",
            url: url,
            data: form,
            headers: { "Content-Type": "multipart/form-data" },
            config: {
              withCredentials: true,
            },
          })
            .then((resp) => {
              self.$vs.notify({
                title: "Rendszerüzenet",
                position: "top-right",
                text: resp.data.status === "OK" ? "Sikeres mentés." : "Sikertelen mentés. " + resp.data.message,
                color: resp.data.status === "OK" ? "success" : "danger",
                icon: resp.data.status === "OK" ? "check_box" : "error",
              });
              // Kép frissítése a mentés után
              if (resp.data.status === "OK") {
                let input = document.getElementById("fileUpload_edit");
                if (input !== null && input.files !== null && input.files.length !== 0) {
                  self.selected.ItemFileName = self.item.ItemFileName;
                  self.imgSrc = self.$root.imagePath + self.item.ItemFileName;
                }
              }
              self.$parent.$emit("closemodal");
            })
            .catch((err) => {
              if (err.response.status === 401) self.$root.exterminatus();
              else {
                self.$vs.notify({
                  title: "Rendszerüzenet",
                  position: "top-right",
                  text: err.response.data.message,
                  color: "danger",
                  icon: "error",
                });
              }
            });
        },
      });
    },
    formatEcommerceCode() {
      // Remove all characters except letters, numbers
      let sanitizedCode = this.ecommerceCodeInput.replace(/[^a-zA-Z0-9]/g, "");

      // Group characters in chunks of 5 and join them with commas
      sanitizedCode = sanitizedCode.match(/.{1,5}/g)?.join(",") || "";

      this.ecommerceCodeInput = sanitizedCode;
      this.item.EcommerceCode = sanitizedCode; // Explicitly set on the item object
      this.selected.EcommerceCode = sanitizedCode;
    },
    updateMenu(menuId) {
      if (this.menuToAdd === this.originalMenu) return;

      let self = this;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `Megerősítés`,
        text: "Valóban módosítja a hozzárendelt menüt?",
        acceptText: "Igen",
        cancelText: "Nem",
        accept: function () {
          let payload = { MenuId: menuId, ItemId: self.item.ItemId };
          if (self.originalMenu) {
            payload.OriginalId = self.originalMenu;
          }
          axiosInstance
            .post("admin/itemMenuController.php", payload, {
              withCredentials: true,
            })
            .then((resp) => {
              self.$vs.notify({
                title: "Rendszerüzenet",
                position: "top-right",
                text: resp.data.status === "OK" ? "Sikeres módosítás." : "Sikertelen módosítás. " + resp.data.message,
                color: resp.data.status === "OK" ? "success" : "danger",
                icon: resp.data.status === "OK" ? "check_box" : "error",
              });
              self.$parent.$emit("updateList");
            })
            .catch((err) => {
              if (err.response.status === 401) self.$root.exterminatus();
              else {
                self.$vs.notify({
                  title: "Rendszerüzenet",
                  position: "top-right",
                  text: err.response.data.message,
                  color: "danger",
                  icon: "error",
                });
              }
            });
        },
        cancel: function () {
          self.menuToAdd = self.originalMenu;
        },
      });
    },
    updateCategory(catId) {
      if (this.categoryToAdd === this.originalCategory) return;

      let self = this;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `Megerősítés`,
        text: "Valóban módosítja a kategóriát?",
        acceptText: "Igen",
        cancelText: "Nem",
        accept: function () {
          let payload = {
            CategoryId: catId,
            ItemId: self.item.ItemId,
          };
          if (self.originalCategory != null && self.originalCategory !== "") {
            payload.OriginalId = self.originalCategory;
          }
          axiosInstance
            .post("admin/itemCategoryController.php", payload, {
              withCredentials: true,
            })
            .then((resp) => {
              self.$vs.notify({
                title: "Rendszerüzenet",
                position: "top-right",
                text: resp.data.status === "OK" ? "Sikeres módosítás." : "Sikertelen módosítás. " + resp.data.message,
                color: resp.data.status === "OK" ? "success" : "danger",
                icon: resp.data.status === "OK" ? "check_box" : "error",
              });
              self.originalCategory = self.categoryToAdd;
              self.$parent.$emit("updateList");
            })
            .catch((err) => {
              if (err.response.status === 401) self.$root.exterminatus();
              else {
                self.$vs.notify({
                  title: "Rendszerüzenet",
                  position: "top-right",
                  text: err.response.data.message,
                  color: "danger",
                  icon: "error",
                });
              }
            });
        },
        cancel: function () {
          self.originalCategory === undefined
            ? (self.categoryToAdd = "")
            : (self.categoryToAdd = self.originalCategory);
        },
      });
    },
    addAddon(addonId) {
      let self = this;
      let doesItExists = self.item.ItemAddons.find((elem) => elem.AddonId === addonId);
      if (doesItExists !== undefined) {
        self.$vs.notify({
          title: "Rendszerüzenet",
          position: "top-right",
          text: "Ezt a kiegészítőt már tartalmazza a cikk.",
          color: "warning",
          icon: "warning",
        });
        return;
      }

      axiosInstance
        .put(
          "admin/itemAddonController.php",
          { AddonId: addonId, ItemId: self.item.ItemId },
          {
            withCredentials: true,
          },
        )
        .then((resp) => {
          self.$vs.notify({
            title: "Rendszerüzenet",
            position: "top-right",
            text: resp.data.status === "OK" ? "Sikeres hozzáadás." : "Sikertelen hozzáadás. " + resp.data.message,
            color: resp.data.status === "OK" ? "success" : "danger",
            icon: resp.data.status === "OK" ? "check_box" : "error",
          });
          self.item.ItemAddons.push({ ...this.addonList.find((elem) => elem.Id === addonId) });
        })
        .catch((err) => {
          if (err.response.status === 401) self.$root.exterminatus();
          else {
            self.$vs.notify({
              title: "Rendszerüzenet",
              position: "top-right",
              text: err.response.data.message,
              color: "danger",
              icon: "error",
            });
          }
        });
    },
    removeAddon(addon) {
      let self = this;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `Megerősítés`,
        text: "Valóban törli az kiegészítőt?",
        acceptText: "Igen",
        cancelText: "Nem",
        accept: function () {
          axiosInstance
            .delete("admin/itemAddonController.php?addonId=" + addon.AddonId + "&itemId=" + self.item.ItemId, {
              withCredentials: true,
            })
            .then((resp) => {
              self.$vs.notify({
                title: "Rendszerüzenet",
                position: "top-right",
                text: resp.data.status === "OK" ? "Sikeres törlés." : "Sikertelen törlés. " + resp.data.message,
                color: resp.data.status === "OK" ? "success" : "danger",
                icon: resp.data.status === "OK" ? "check_box" : "error",
              });
              self.item.ItemAddons.splice(self.item.ItemAddons.indexOf(addon), 1);
            })
            .catch((err) => {
              if (err.response.status === 401) self.$root.exterminatus();
              else {
                self.$vs.notify({
                  title: "Rendszerüzenet",
                  position: "top-right",
                  text: err.response.data.message,
                  color: "danger",
                  icon: "error",
                });
              }
            });
        },
      });
    },
    addLabel(labelId) {
      let self = this;
      let doesItExists = self.item.ItemLabels.find((elem) => elem.LabelId === labelId);
      if (doesItExists !== undefined) {
        self.$vs.notify({
          title: "Rendszerüzenet",
          position: "top-right",
          text: "Ezt a címkét már tartalmazza a cikk.",
          color: "warning",
          icon: "warning",
        });
        return;
      }

      axiosInstance
        .put(
          "admin/itemLabelController.php",
          { LabelId: labelId, ItemId: self.item.ItemId },
          {
            withCredentials: true,
          },
        )
        .then((resp) => {
          self.$vs.notify({
            title: "Rendszerüzenet",
            position: "top-right",
            text: resp.data.status === "OK" ? "Sikeres hozzáadás." : "Sikertelen hozzáadás. " + resp.data.message,
            color: resp.data.status === "OK" ? "success" : "danger",
            icon: resp.data.status === "OK" ? "check_box" : "error",
          });
          self.item.ItemLabels.push({ ...this.labelList.find((elem) => elem.Id === labelId) });
        })
        .catch((err) => {
          if (err.response.status === 401) self.$root.exterminatus();
          else {
            self.$vs.notify({
              title: "Rendszerüzenet",
              position: "top-right",
              text: err.response.data.message,
              color: "danger",
              icon: "error",
            });
          }
        });
    },
    removeLabel(label) {
      let self = this;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `Megerősítés`,
        text: "Valóban törli a címkét?",
        acceptText: "Igen",
        cancelText: "Nem",
        accept: function () {
          axiosInstance
            .delete("admin/itemLabelController.php?labelId=" + label.LabelId + "&itemId=" + self.item.ItemId, {
              withCredentials: true,
            })
            .then((resp) => {
              self.$vs.notify({
                title: "Rendszerüzenet",
                position: "top-right",
                text: resp.data.status === "OK" ? "Sikeres törlés." : "Sikertelen törlés. " + resp.data.message,
                color: resp.data.status === "OK" ? "success" : "danger",
                icon: resp.data.status === "OK" ? "check_box" : "error",
              });
              self.item.ItemLabels.splice(self.item.ItemLabels.indexOf(label), 1);
            })
            .catch((err) => {
              if (err.response.status === 401) self.$root.exterminatus();
              else {
                self.$vs.notify({
                  title: "Rendszerüzenet",
                  position: "top-right",
                  text: err.response.data.message,
                  color: "danger",
                  icon: "error",
                });
              }
            });
        },
      });
    },
    setImage() {
      let self = this;
      let input = document.getElementById("fileUpload_edit");
      if (input.files && input.files[input.files.length - 1]) {
        let reader = new FileReader();
        if (input.files[input.files.length - 1].size / 1024 / 1024 > 2) {
          self.$vs.dialog({
            color: "danger",
            title: "Hiba",
            text: "A fájl mérete túl nagy. A maximum megengedett fájlméret 2 megabyte.",
            buttonAccept: "Rendben",
          });
          input.value = "";
          return;
        }
        reader.readAsDataURL(input.files[input.files.length - 1]);
        reader.onload = function (e) {
          self.imgSrc = e.target.result;
        };
      }
    },
    isNotSaveable() {
      return !this.item.ItemName || !Number.isInteger(parseInt(this.item.ItemPrice));
    },
  },
};
</script>

<style scoped>
.con-vs-checkbox {
  margin-top: 15px;
}

.vs-input,
.con-select {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
}

.vs-textarea-primary {
  margin-top: 15px;
}

form {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

label {
  text-align: center;
}

.itemImage {
  border: 1px solid #ccc;
  width: 270px;
  height: 190px;
  overflow: hidden;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
  background-size: cover;
}
</style>
